import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import TextField from '../TextField'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * When true, allows non-integer values (Graph Edm.Double-style fields).
   */
  decimals: PropTypes.bool,
}

const toNumberOrEmpty = (raw) => {
  if (raw === '' || raw === null || raw === undefined) return ''
  const n = Number(raw)
  return Number.isFinite(n) ? n : ''
}

/**
 * Formik-connected number input that stores numbers in Formik state.
 * Keeps '' as '' so the input can be cleared without becoming NaN.
 */
function FormikNumberField(props) {
  const { id, decimals = false, ...rest } = props ?? {}

  return (
    <Field name={id}>
      {({ field, meta, form }) => (
        <TextField
          {...rest}
          id={id}
          name={id}
          type="number"
          step={decimals ? 'any' : 1}
          inputMode={decimals ? 'decimal' : 'numeric'}
          pattern={decimals ? undefined : '[0-9]*'}
          value={field.value ?? ''}
          onChange={(event) => {
            const raw = event?.target?.value
            form.setFieldValue(id, toNumberOrEmpty(raw))
          }}
          onBlur={(event) => {
            form.setFieldTouched(id, true)
            field.onBlur(event)
          }}
          errors={meta.touched && meta.error ? [meta.error] : []}
        />
      )}
    </Field>
  )
}

FormikNumberField.propTypes = propTypes

export default FormikNumberField
